/**
 * Currency CHIRP V2 Migration Feature Flag
 *
 * This flag controls whether to use CHIRP V2 endpoints or fallback to REST.
 * Set to false to immediately revert to REST endpoints if issues arise.
 *
 * Isolated in its own file to keep early requester bundle size minimal.
 *
 * NOTE: Intentionally hardcoded rather than using Laboratory/getFeatureFlagsRpc because:
 * - Currency early requesters fire before the app loads (need synchronous flag value)
 * - Currency is critical path - can't wait for flag API to resolve
 * - For gradual rollout, use canary deploys (10% → 50% → 100% of pods)
 * - All-or-nothing flip is safer for currency than per-user rollout
 */
export const USE_CURRENCY_CHIRP_V2 = true;